export const sentryDedupeSuffix = '[sentry:dedupe]';

export const ignoredErrorMessages = [
  // From RO author: "This error means that ResizeObserver was not able to deliver all observations within
  // a single animation frame. It is benign (your site will not break)."
  // https://stackoverflow.com/questions/49384120/resizeobserver-loop-limit-exceeded#comment86691361_49384120
  'ResizeObserver loop limit exceeded',
  'ResizeObserver loop completed with undelivered notifications',

  // This is MSFT Safe Link agent with poor JS compatibility
  // https://forum.sentry.io/t/unhandledrejection-non-error-promise-rejection-captured-with-value/14062/4
  // (as mentioned in that thread, confirmed the IPs via who.is)
  'Object Not Found Matching Id',

  // Displayed on every rate-limited request
  'status code 429',

  // This is an Edge Bing Instant Search bar error
  // https://stackoverflow.com/questions/69261499/what-is-instantsearchsdkjsbridgeclearhighlight
  "Can't find variable: instantSearchSDKJSBridgeClearHighlight",

  // We add a safety try/catch when accessing local storage which gets hit in environments
  // where local storage is unavailable. Leaving a console.error in the event it's helpful
  // debugging any future issue that might have a fragile dependency on its availability.
  'Storage may not be available in this environment.',

  // Ignore errors that are already explicitly captured by sentry and printed
  // to the console from the captureAndLogError function.
  sentryDedupeSuffix,
];
